import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { Modal, Button, Form } from 'react-bootstrap'

type Props = {
  show: boolean
  onHide: () => void
  onSubmit: (reason: string) => void
  title?: string
  placeholder?: string
}

const RejectionReasonModal: React.FC<Props> = ({ show, onHide, onSubmit, title, placeholder }) => {
  const intl = useIntl()
  const [reason, setReason] = useState('')
  const [error, setError] = useState('')

  useEffect(() => {
    if (!show) {
      setReason('')
      setError('')
    }
  }, [show])

  const handleSubmit = () => {
    if (!reason.trim()) {
      setError(intl.formatMessage({ id: 'MODAL.REASON_REQUIRED', defaultMessage: 'Reason is required.' }))
      return
    }
    onSubmit(reason.trim())
  }

  return (
    <Modal show={show} onHide={onHide} centered size='lg'>
      <Modal.Header closeButton>
        <Modal.Title>
          {title ?? intl.formatMessage({ id: 'DRAWER.REASON_FOR_REJECTION', defaultMessage: 'Enter Reason for Rejection' })}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Control
            as='textarea'
            rows={3}
            className='fs-4 fs-sm-4 fs-md-4 fs-lg-2 fs-xl-2'
            value={reason}
            onChange={(e) => {
              setReason(e.target.value)
              setError('')
            }}
            placeholder={placeholder ?? intl.formatMessage({ id: 'DRAWER.REJECTION_REASON_PLACEHOLDER', defaultMessage: 'Enter rejection reason' })}
          />
          {error && <Form.Text className='text-danger'>{error}</Form.Text>}
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onHide}>
          {intl.formatMessage({ id: 'MODAL.CANCEL', defaultMessage: 'Cancel' })}
        </Button>
        <Button variant='danger' onClick={handleSubmit}>
          {intl.formatMessage({ id: 'MODAL.CONFIRM', defaultMessage: 'Confirm' })}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default RejectionReasonModal
